export const otherProjects = [
  {
    title: "Period Tracker",
    description:
      "Period Cycle meticulously, receive insightful Mood Analysis, and access information about nearby hospitals and gynecologists for their medical needs.",
    gitLink: "https://github.com/Yash-Sajwan24/PeriodPixie",
    liveLink: "https://drive.google.com/file/d/1lQAKxtWhPXBVnXIkbZ_CUf4Zjd3DzvZS/view",
    listItems:["React.js", "numpy", "Pandas", "Tailwind", "Google Maps", "Firebase"],
  },
  {
    title: "Campus Ambassador Portal",
    description:
      "A comprehensive web application designed to streamline and enhance campus ambassador programs.",
    gitLink: "https://github.com/Yash-Sajwan24/Community-Ambassador-Management-Portal",
    liveLink: "https://github.com/Yash-Sajwan24/Community-Ambassador-Management-Portal",
    listItems:["Express.Js", "CSS", "Tailwind", "Node.Js", "Javascript"],
  },

  {
    title: "Golds Gym",
    description:
      "This React-based website showcases a gym's services, classes, trainers, and contact details.",
    gitLink: "https://github.com/Yash-Sajwan24/Gym-Exercise",
    liveLink: "https://goldsgym24.netlify.app/",
    listItems:["React", "CSS", "Rapid Api", "Materail UI"],
  },
  {
    title: "Mars Delight",
    description:
      "Indulge in an otherworldly culinary experience at Mars Delight - where the flavors of the red planet meet the finest in dining. Experience the taste of a new world at Mars Delight - the premier restaurant on the red planet.",
    gitLink: "https://github.com/Yash-Sajwan24/Mars-Delight",
    liveLink: "https://mars-delight.vercel.app/",
    listItems: ["React.Js", "Solidity", "Redux", "Spline"],
  },
  {
    title: "Expenses Tracker",
    description:
      "A solution designed to streamline and simplify expense management, making it easier than ever to take charge of your finances.",
    gitLink: "https://github.com/Yash-Sajwan24/Expenses-React-App",
    liveLink: "https://github.com/Yash-Sajwan24/Expenses-React-App",
    listItems: ["React.Js", "CSS", "Javascript", "Lottie-animation"],
  },
  {
    title: "Organ-ise",
    description:
      "an innovative solution that digitalizes organ donation. This system enhances the existing organ donation framework by introducing transparency, scalability, and security through blockchain technology.",
    gitLink: "https://github.com/Yash-Sajwan24/Organ-ise-Organ-Donation-Blockchain",
    liveLink: "https://github.com/Yash-Sajwan24/Organ-ise-Organ-Donation-Blockchain",
    listItems: ["React.Js", "API", "Solana", "Tailwind", "CSS"],
  },
];
